import { useQuery, UseQueryOptions } from 'react-query';
import {
  GetAuthConfigsResponse,
  GetSsoDetailsForTenantResponse,
} from '@weave/schema-gen-ts/dist/schemas/auth-api/v3/auth.pb';
import { getAuthConfigs, getSsoDetailsForTenant, getSsoExcludedUsers } from './api';

export const SsoQueryKeys = {
  GET_SSO_DETAILS: 'sso-details-for-tenant',
  GET_AUTH_CONFIGS: 'sso-auth-configs',
  GET_SSO_EXCLUDED_USERS: 'sso-excluded-users',
};

export const useGetSsoDetailsForTenant = <T = GetSsoDetailsForTenantResponse>(
  locationId: string,
  options?: Pick<UseQueryOptions<GetSsoDetailsForTenantResponse, unknown, T>, 'select'>
) =>
  useQuery<GetSsoDetailsForTenantResponse, unknown, T>({
    queryKey: [SsoQueryKeys.GET_SSO_DETAILS, locationId],
    queryFn: () => getSsoDetailsForTenant(locationId),
    enabled: !!locationId,
    retry: false,
    ...options,
  });

export function useGetAuthConfigs(
  tenant: string,
  locationId: string,
  options?: UseQueryOptions<GetAuthConfigsResponse, Error>
) {
  return useQuery<GetAuthConfigsResponse, Error>(
    [SsoQueryKeys.GET_AUTH_CONFIGS, tenant, locationId],
    () => getAuthConfigs(tenant, locationId),
    {
      enabled: !!tenant && !!locationId,
      ...options,
    }
  );
}

export const useGetSsoExcludedUsers = (locationId: string) =>
  useQuery({
    queryKey: [SsoQueryKeys.GET_SSO_EXCLUDED_USERS, locationId],
    queryFn: () => getSsoExcludedUsers(locationId),
    enabled: !!locationId,
    retry: false,
  });
